var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{ref:"input",tag:"component",staticClass:"v-picker",attrs:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }